<template>
  <div class="item-list">
    <el-row>
      <el-col :span="24">
        <el-alert
            title="温馨提示"
            type="success"
            close-text="知道了"
            show-icon>
          <p>设置后，用户打开小程序会提示关注</p>
          <p><a style="color: red" href="https://www.yuque.com/yifakeji/irpssl/tg827f" target="_blank">引导关注教程</a></p>
        </el-alert>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-form ref="config-item" :model="item" label-width="190px"
                 label-position="left">
          <el-form-item label="是否开启" prop="open">
            <el-switch v-model="item.open"></el-switch>
          </el-form-item>
          <el-form-item label="请选择公众号">
            <el-select v-model="item.mpAuthConfigId" placeholder="请选择公众号">
              <el-option
                  v-for="item in mpAuthConfigs"
                  :key="item.id"
                  :label="item.nickName"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="类型" prop="type">
            <el-col :span="12">
              <el-radio-group v-model="item.type">
                <el-radio border :label="'webUrl'">跳转公众号网页</el-radio>
                <el-radio border :label="'pagePath'">跳转小程序页面</el-radio>
                <el-radio border :label="'qrcode'">弹窗二维码</el-radio>
              </el-radio-group>
            </el-col>
            <el-col :span="24">
              <el-alert
                  close-text="知道了"
                  type="success">
                <p class="alter-text">跳转公众号网页：跳转到公众号页面关注</p>
                <p class="alter-text">跳转小程序页面：跳转到小程序帮助页面</p>
                <p class="alter-text">弹窗二维码：弹窗公众号二维码，长按识别</p>
              </el-alert>
            </el-col>
          </el-form-item>
          <el-form-item label="是否开启提现关注" prop="openWithdrawGuide">
            <el-switch v-model="item.openWithdrawGuide"></el-switch>
            <el-col :span="24">
              <el-alert
                  close-text="知道了"
                  type="success">
                <p class="alter-text">开启后，如果用户小程序提现，但是没有关注公众号就会提示关注公众号</p>
                <p class="alter-text">关注公众号以后，就会自动将最近提现的一笔提现，自动发红包</p>
              </el-alert>
            </el-col>
          </el-form-item>
<!--          <el-form-item label="提现提示标题" prop="withdrawGuideTitle">
            <el-input v-model="item.withdrawGuideTitle" placeholder="关注公众号"></el-input>
          </el-form-item>
          <el-form-item label="提现提示文案" prop="withdrawGuideTips">
            <el-input v-model="item.withdrawGuideTips" placeholder="关注公众号"></el-input>
          </el-form-item>-->
          <el-form-item label="公众号信息" prop="name">
            <el-input v-model="item.name" placeholder="关注公众号"></el-input>
          </el-form-item>
          <el-form-item label="提示信息" prop="tip">
            <el-input v-model="item.tip" placeholder="获取更多优惠"></el-input>
          </el-form-item>
          <el-form-item label="操作名称" prop="optName">
            <el-input v-model="item.optName" placeholder="去关注"></el-input>
          </el-form-item>
          <el-form-item label="网页链接" prop="webUrl" v-if="item.type=='webUrl'">
            <el-input v-model="item.webUrl" placeholder="请输入网页链接"></el-input>
          </el-form-item>
          <el-form-item label="页面路径" prop="pagePath" v-if="item.type=='pagePath'">
            <el-input v-model="item.pagePath" placeholder="请输入页面路径"></el-input>
          </el-form-item>
          <el-form-item label="二维码图片" prop="qrcodeImg" v-if="item.type=='qrcode'">
            <el-input v-model="item.qrcodeImg" placeholder="请输入公众号二维码图片地址"></el-input>
          </el-form-item>
          <el-form-item label="弹窗提示" prop="qrcodeTip" v-if="item.type=='qrcode'">
            <el-input v-model="item.qrcodeTip" placeholder="长按上面图片，关注公众号"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">保存</el-button>
          </el-form-item>
        </el-form>
      </el-col>

    </el-row>
  </div>
</template>
<script>
import {mpAuthConfigApi} from "../../common/mpAuthConfigApi";
import {showMpConfigApi} from "@/common/showMpConfigApi";

export default {
  name: "items",
  props: {},
  computed: {},
  watch: {
    'item.type': {
      handler: function () {
        if (this.item.type == 'qrcode') {
        }
      }
    },
  },
  data() {
    return {
      page: 1,
      pageSize: 10,
      keyword: null,
      items: [],
      item: {
        name: "关注公众号",
        tip: "获取更多优惠",
        optName: '去关注',
        webUrl: '',
        type: 'webUrl',
        pagePath: '',
        mpAuthConfigId: '',
        qrcodeImg: '',
        qrcodeTip: ''
      },
      mpAuthConfigs: []
    }
  },

  created() {
    var that = this;
    mpAuthConfigApi.getMpAuthConfigs.call(that, {}, function (res) {
      if (res.result.mpConfigs) {
        that.mpAuthConfigs = res.result.mpConfigs;
        if (that.mpAuthConfigs.length > 0) {
          if (!that.item.mpAuthConfigId) {
            that.item.mpAuthConfigId = that.mpAuthConfigs[0].id;
          }
        }
      } else {
        that.failMsg("获取公众号信息出错");
      }
    })

    showMpConfigApi.getItems.call(that, {}, function (res) {
      if (res.result.data && res.result.data.length > 0) {
        that.item = res.result.data[0];
      } else {
      }

    });

  },
  mounted() {
  },
  methods: {

    objectValueOfProperty(items, key) {
      var newArry = []
      for (var i = 0; i < items.length; i++) {
        newArry.push(items[i][key])
      }
      return newArry;
    },
    onSubmit() {
      var that = this
      if (that.item.type == 'webUrl') {
        if (this.isEmpty(that.item.webUrl)) {
          that.failMsg("网页链接必须填写");
          return
        }
      } else if (that.item.type == 'pagePath') {
        if (this.isEmpty(that.item.pagePath)) {
          that.failMsg("页面路径必须填写");
          return
        }
      } else if (that.item.type == 'qrcode') {
        if (this.isEmpty(that.item.qrcodeImg)) {
          that.failMsg("二维码图片必须填写");
          return
        }
      }
      showMpConfigApi.createItem.call(that, that.item, function (res) {
      });
    },

    handleCurrentChange() {


    }
  }
}

</script>
<style lang="scss">

.item-list {

  .el-form-item {
    .el-select {
      width: 100%;
    }

    .el-form-item__content {
      text-align: left;
    }
  }

  .el-alert {
    line-height: 25px;
  }

  .media-image {
    width: 30px;
    height: 30px;
    border-radius: 30px;
    vertical-align: middle;
    margin-right: 10px;
  }


  .el-form-item {
  }

  .el-button {
    margin-left: 5px;
  }

  .input-text {
    width: 400px;
  }

  .el-form-item__label {
    width: 100px;
  }

  .pagination {
    position: relative;

    .operation {
      float: left;

      button {
        margin-right: 10px;
      }
    }
  }

  .operation {
    .el-button {
      margin: 5px !important;
      display: inline-block;
    }
  }
}


</style>